import React, { useCallback, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Layout from '../../components/layout/AppLayout';
import Header from '../../../shared/components/layout/Header';
import { useSidebar } from '../../../shared/contexts/SidebarContext';
import SalesGraphs from '../Sales/SalesGraphs';
import SalesDashboard from '../Sales/SalesDashboard';
import DashboardFilters from '../../../shared/components/ui/DashboardFilters';
import Loader from '../../../shared/components/ui/Loader';
import Reports from '../Sales/Reports';
import { useSmartBack } from '../../../shared/navigation';

const Configure = () => {
  const { collapsed } = useSidebar();
  const location = useLocation();
  const { onBack } = useSmartBack({ fallback: '/builder/management' });
  const [secondaryTab, setSecondaryTab] = useState('Reports');
  const [selectedCard, setSelectedCard] = useState(null);
  const [filters, setFilters] = useState({
    projectID: location.state?.projectID || null,
    month: location.state?.month || null
  });
  const [isFiltersLoading, setIsFiltersLoading] = useState(false);

  useEffect(() => {
    // Get the selected card from navigation state (should always be 'Sales' now)
    if (location.state?.selectedCard) {
      setSelectedCard(location.state.selectedCard);
    } else {
      // Default to Sales if no card specified
      setSelectedCard('Sales');
    }

    // Initialize filters from location state if provided
    if (location.state?.projectID || location.state?.month) {
      setFilters({
        projectID: location.state.projectID || null,
        month: location.state.month || null
      });
    }
  }, [location.state]);

  const secondaryTabbedComponentMetaData = {
    tabs: ['Reports', 'Graphs']
  };

  const handleChangeSecondaryTab = useCallback((tabName) => {
    setSecondaryTab(tabName);
  }, []);

  // Render Sales Graphs
  const renderDashboard = () => {
    return <SalesGraphs projectID={filters.projectID} month={filters.month} />;
  };

  const handleFiltersChange = ({ projectID, month }) => {
    setFilters({ projectID, month });
  };

  const handleFiltersLoadingChange = (isLoading) => {
    setIsFiltersLoading(isLoading);
  };

  /* 
    JSX
  */
  return (
    <>
      {/* Main content */}
      <Layout>
        <Loader isVisible={isFiltersLoading} />
        {/* Header */}
        <div
          className={`fixed z-[10] top-0 transition-all duration-300 ease-in-out ${
            collapsed ? 'left-[76px] right-0' : 'left-64 right-0'
          }`}>
          <Header data={{ name: selectedCard }} backArrow={true} onBack={onBack} />
        </div>

        <div className={` relative mt-[4rem]`}>
          {/* Compact Combined Tab Navigation with Filters */}
          {/* <Headroom
            upTolerance={20}
            downTolerance={20}
            offset={20}
            style={{
              transition: 'all 0.28s ease-in-out',
              position: 'fixed',
              top: '4rem',
              left: collapsed ? '76px' : '16.6%',
              right: '0',
              zIndex: 2
            }}> */}
          <div className="bg-white w-full fixed top-[4.1rem] z-10">
            {/* Tabs */}
            <div className="border-b border-gray-200">
              <div className="flex justify-between items-center pl-4 py-3">
                {/* All Tabs */}
                <div className="flex items-center space-x-0.5">
                  {secondaryTabbedComponentMetaData.tabs.map((item, index) => (
                    <div
                      key={index}
                      className={`px-3 py-1 text-sm cursor-pointer transition-all duration-200 rounded-md font-semibold ${
                        item === secondaryTab
                          ? 'bg-primary text-white font-medium'
                          : 'text-gray-600 hover:bg-gray-100'
                      }`}
                      onClick={() => handleChangeSecondaryTab(item)}>
                      {item}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Filters - Show for all cards */}
            <div className="border-b border-gray-200">
              <DashboardFilters
                onFiltersChange={handleFiltersChange}
                onLoadingChange={handleFiltersLoadingChange}
                useRelativePosition={true}
                initialProjectID={location.state?.projectID}
                initialMonth={location.state?.month}
              />
            </div>
          </div>
          {/* </Headroom> */}
        </div>
        {/* Content based on selected tab */}
        <div className="mb-[2rem] mt-[7rem]">
          {/* Reports tab */}
          {secondaryTab === 'Reports' && (
            <Reports mode="view" projectID={filters.projectID} month={filters.month} />
          )}

          {/* Graphs tab */}
          {secondaryTab === 'Graphs' && (
            <div className="w-full h-full">
              <SalesDashboard
                skipLayout={true}
                skipHeader={true}
                skipFilters={true}
                projectID={filters.projectID}
                month={filters.month}
                onFiltersChange={handleFiltersChange}
              />
            </div>
          )}
        </div>
      </Layout>
    </>
  );
};

export default Configure;
